import React from "react";
import BackdropItem from "./BackdropItem/BackdropItem";
import Aux from "../../hoc/Auxilliary";

const Backdrop = (props) => {
  return <Aux>{props.show ? <BackdropItem /> : null}</Aux>;
};

export default Backdrop;
